// Stripe configuration
// Get your publishable key from: https://dashboard.stripe.com/apikeys
// For development, use test keys (pk_test_...)
// For production, use live keys (pk_live_...)

export const STRIPE_PUBLISHABLE_KEY =
  process.env.EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY!;
